import { ITimedEvent } from "@/helpers/format-prayer-tide";
import tidesIcon from "@/img/tiles-icon.svg";
import "./style.scss";
import { useTranslation } from "react-i18next";

type TilesPrayerCardProps = {
	data?: ITimedEvent;
	currentType?: "upwelling" | "downwelling";
};

export const TilesPrayerCard = ({
	data,
	currentType,
}: TilesPrayerCardProps) => {
	const { t } = useTranslation();

	return currentType ? (
		<div className="tiles-prayer-card welling">
			<p>{t("currentType")} </p>

			<div className="value">
				<img src={tidesIcon} alt={"tides icon"} />
				<p>{t(currentType)}</p>
			</div>
		</div>
	) : (
		data && (
			<div className="tiles-prayer-card">
				<p>{data.label}</p>
				<p>{data.timeFormatted}</p>
			</div>
		)
	);
};

export default TilesPrayerCard;
